import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UploadModule } from 'src/app/shared/modules/upload/upload.module';
import { FeedsRoutingModule } from './feeds-routing.module';
import { AddNewsfeedCategoryComponent } from './pages/add-newsfeed-category/add-newsfeed-category.component';
import { AddNewsfeedPopupComponent } from './pages/add-newsfeed-popup/add-newsfeed-popup.component';
import { ScrollTrackerDirective } from './pages/directives/scroll-tracker.directive';
import { FeedImageComponent } from './pages/feed-image/feed-image.component';
import { FeedVideoComponent } from './pages/feed-video/feed-video.component';
import { FeedComponent } from './pages/feed/feed.component';
import { FollowersComponent } from './pages/followers/followers.component';
import { FollowingComponent } from './pages/following/following.component';
import { LikedUsersPopupComponent } from './pages/liked-users-popup/liked-users-popup.component';
import { ListNewsfeedCategoryComponent } from './pages/list-newsfeed-category/list-newsfeed-category.component';
import { SingleFeedComponent } from './pages/single-feed/single-feed.component';
import { CommonService } from './services/common.service';
import { FeedService } from './services/feed.service';
import { MultiSelectService } from './services/multiselect.service';
import { FeedUrlVideoComponent } from './pages/feed-url-video/feed-url-video.component';
import { EditCommentDialogComponent } from './pages/edit-comment-dialog/edit-comment-dialog.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { FeedDocumentComponent } from './pages/feed-document/feed-document.component';
import { ProfileModule } from '../profile/profile.module';
import { ReplyComponent } from './pages/reply/reply.component';
import { EditReplyDialogComponent } from './pages/edit-reply-dialog/edit-reply-dialog.component';
import { ListJobRoleComponent } from './pages/list-job-role/list-job-role.component';
import { AddJobRoleComponent } from './pages/add-job-role/add-job-role.component';
import { AddEmployeeTypeComponent } from './pages/add-employee-type/add-employee-type.component';
import { ListEmployeeTypeComponent } from './pages/list-employee-type/list-employee-type.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScrollingModule } from '@angular/cdk/scrolling';


@NgModule({
  declarations: [
    FeedComponent,
    FeedVideoComponent,
    FeedImageComponent,
    FeedUrlVideoComponent,
    FollowingComponent,
    FollowersComponent,
    SingleFeedComponent,
    LikedUsersPopupComponent,
    AddNewsfeedPopupComponent,
    ScrollTrackerDirective,
    ListNewsfeedCategoryComponent,
    AddNewsfeedCategoryComponent,
    AddNewsfeedPopupComponent,
    FeedUrlVideoComponent,
    FeedVideoComponent,
    ListNewsfeedCategoryComponent,
    EditCommentDialogComponent,
    FeedDocumentComponent,
    ReplyComponent,
    EditReplyDialogComponent,
    ListJobRoleComponent,
    AddJobRoleComponent,
    AddEmployeeTypeComponent,
    ListEmployeeTypeComponent,
  ],
  imports: [
    CommonModule,
    FeedsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    UploadModule,
    NgxDocViewerModule,
    SwiperModule,
    ProfileModule,
    InfiniteScrollModule,
    ScrollingModule
  ],
  providers:[FeedService,CommonService,MultiSelectService],
  exports: [AddNewsfeedPopupComponent]
})
export class FeedsModule { }
